module.exports = __webpack_public_path__ + "media/images/icon-facebook-026c8d42b8a53551a4a732c5e0fcefae.png";